import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import LogFileCellRenderer from 'components/common/logFileCellRenderer'
import { formatDate } from 'utils/helpers'

export const getColumns = (page: number) =>
  [
    {
      headerName: 'ID',
      field: 'uuid',
      valueFormatter: (params: ValueFormatterParams) => {
        return (params.node?.rowIndex as number) + 1 + page
      },
      maxWidth: 120,
    },
    { headerName: 'API Type', field: 'apiType' },
    {
      headerName: 'Log File',
      field: 'logFile',
      cellRenderer: (params: ICellRendererParams) => (
        <LogFileCellRenderer params={params} />
      ),
    },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    {
      headerName: 'Completion Date',
      field: 'completionDate',
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? formatDate(params.value, { includeTime: true }) : '-',
    },
    { headerName: 'Status', field: 'status' },
  ] as ColDef[]
